
export default class CollapseFiona {
	static initAll() {
		const collapses = document.querySelectorAll('.collapse-fiona');
		collapses.forEach((collapse) => this.init(collapse));
	}

	static init(element) {
		return new this(element);
	}

	constructor(element) {
		this.element = element;

		this.pos = {
			top: 0,
			left: 0,
			x: 0,
			y: 0
		};
	}


}
